// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getProfileAlbums } from "./actions/get-profile-albums.action";
import { getProfileAlbumGalleries } from "./actions/get-profile-album-galleries.action";

// ############################################################

// Initial state
const initialState = {
	albums_list: {
		loading: false,
		loaded: false,
		data: [],
		hash: "",
	},
	current_album: {
		loading: false,
		loaded: false,
	},
};

// ############################################################

// Slice
const userProfileGallerySlice = createSlice({
	name: "user-profile/gallery",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		// Get Profile Albums
		builder.addCase(getProfileAlbums.pending, (state) => {
			state.albums_list.loading = true;
			state.albums_list.data = [];
		});
		builder.addCase(getProfileAlbums.fulfilled, (state, action) => {
			if (!action.payload) {
				state.albums_list.loaded = true;
				state.albums_list.loading = false;
			} else {
				state.albums_list.loading = false;
				state.albums_list.loaded = true;
				state.albums_list.data = action.payload.data ?? [];
				state.albums_list.hash = action.payload.hash ?? "";
			}
		});
		builder.addCase(getProfileAlbums.rejected, (state) => {
			state.albums_list.loading = false;
		});

		// Get Profile Album Galleries
		builder.addCase(getProfileAlbumGalleries.pending, (state, action) => {
			const { albumId, reset } = action.meta.arg;
			if (reset) {
				state.current_album.loading = true;
				state.current_album[albumId] = {
					total: 0,
					photos: state.current_album[albumId]?.photos ?? 0,
					videos: state.current_album[albumId]?.videos ?? 0,
					hash: [],
					data: [],
					pagination: {
						totalPages: 1,
						currentPage: 1,
					},
				};
			} else {
				state.current_album.loading = true;
			}
		});
		builder.addCase(getProfileAlbumGalleries.fulfilled, (state, action) => {
			const { albumId, reset } = action.payload;
			const dataResult = reset
				? [...(action.payload.data?.media ?? [])]
				: [
						...(state.current_album[albumId]?.data ?? []),
						...(action.payload.data?.media ?? []),
				  ];

			state.current_album.loading = false;
			state.current_album.name =
				action.payload.data?.media_album?.album_name;
			state.current_album.isPrivate =
				action.payload.data?.media_album?.album_private;
			state.current_album[albumId] = {
				total: action.payload.data?.total,
				photos: action.payload.data?.photos,
				videos: action.payload.data?.videos,
				hash: action.payload.data?.hash,
				data: reset
					? dataResult
					: dataResult.filter((val, id) => {
							return (
								id ===
								dataResult.findIndex((el) => el.id === val.id)
							);
					  }),
				pagination: {
					totalPages:
						action.payload?.data?.pagination?.totalpages ?? 1,
					currentPage:
						action.payload?.data?.pagination?.currentpage ?? 1,
				},
			};
		});
		builder.addCase(getProfileAlbumGalleries.rejected, (state) => {
			state.current_album.loading = false;
		});
	},
});

// ############################################################

export default userProfileGallerySlice.reducer;

// Export actions
export { getProfileAlbums, getProfileAlbumGalleries };

// ############################################################
